import api from './client';

export const login = async (username, password) => {
    const { data } = await api.post('/auth', { username, password });
    return data;
};
